import './footer.css';
import PrivacyPolicy from '../privacy_policy/privacy_policy.tsx';

function Footer() {
    return (
        <div className="footer">
            <span className="footer__copyright">
                <img
                    src="https://stazweuathenastorage.blob.core.windows.net/static/images/sensirion_s_square_100.jpg"
                    alt="Branding"
                />
                © 2025 Sensirion AG
            </span>
            <PrivacyPolicy></PrivacyPolicy>
        </div>
    );
}

export default Footer;
